import { Component, Input, OnDestroy } from '@angular/core';

import { BaseDirective } from '../base.component';

@Component({
  selector: 'app-popover',
  template: `
    @if (_open) {
      <div
        class="popover-content-wrapper popover-{{ position }} popover-{{
          orient
        }}"
        [style.left.px]="left"
        [style.top.px]="top"
      >
        <ng-content></ng-content>
      </div>
    }
  `,
  styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent extends BaseDirective implements OnDestroy {
  _open = false;
  @Input() set open(value: boolean) {
    this._open = value;
  }
  @Input() left = 0;
  @Input() top = 0;
  @Input() orient = 'center-above' as const;
  @Input() position = 'absolute' as const;

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.open = false;
  }
}
